import httpService from "./httpService";
import JwtDecode from "jwt-decode";
import { ToastContainer, toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

const tokenKey = "token";

httpService.seJwt(getJwt());

export async function sendOtp(id) {
  const { data: response } = await httpService
    .get("/customer/SendOtp/" + id)
    .catch(function (error) {
      console.log(error);
    });
  return response;
}

export async function checkOtp(id, otpPassword) {
  const { data: jwt } = await httpService
    .get(`/customer/CheckOtp/${id}/${otpPassword}`)
    .catch(function (error) {
      console.log(error);
    });
  if (!jwt?.errorResponse) {
    localStorage.setItem(tokenKey, jwt?.token);
  }
  return jwt;
}

export async function login(UserModel) {
  const Username = UserModel.userName;
  const Password = UserModel.password;
  const { data: jwt } = await httpService
    .post("/customer/login", { Username, Password })
    .catch(function (error) {
      console.log(error);
    });
  if (!jwt?.errorResponse) {
    localStorage.setItem(tokenKey, jwt?.token);
  }
  return jwt;
}

export async function loginWithJwt(jwt) {
  localStorage.setItem(tokenKey, jwt);
  return;
}
export function getCurrentUser() {
  try {
    const dataKey = getDataFromKey();
    return dataKey;
  } catch (ex) {
    return null;
  }
}
export function checkTimeout() {
  const dataKey = getDataFromKey();
  if (dataKey === null) {
    return null;
  }
  const Validate = Date.parse(dataKey.Validate);
  if (Validate - Date.parse(new Date()) < 0) {
    localStorage.removeItem(tokenKey);
    return null;
  }
}
export function getDataFromKey() {
  try {
    const Jwt = localStorage.getItem(tokenKey);
    const Container = JwtDecode(Jwt);
    const dataKey = JSON.parse(Container.props);
    return dataKey;
  } catch {
    return null;
  }
}
export function logout() {
  // customerService.clear();
  localStorage.removeItem(tokenKey);
}
export function getJwt() {
  return localStorage.getItem(tokenKey);
}
export default {
  login,
  logout,
  getCurrentUser,
  getJwt,
  getDataFromKey,
  checkTimeout,
  sendOtp,
  checkOtp,
};
